import React from 'react';
import { usePathname } from 'next/navigation';
import { isShareData } from '@/utils/type-guards';

export function useShareData({
  isUrl = true,
  onSuccess,
}: { isUrl?: boolean; onSuccess?: () => void } = {}) {
  const pathname = usePathname();
  const canShare = typeof window !== 'undefined' && 'share' in navigator;
  async function shareUrl(shareData?: ShareData | React.MouseEvent) {
    const shareDataLocal = isShareData(shareData) ? shareData : null;
    const finalShareData = isUrl ? { url: pathname } : shareDataLocal;

    if (canShare && finalShareData) {
      try {
        onSuccess?.();
        await navigator.share(finalShareData);
      } catch (err) {
        console.error('Error sharing:', err);
      }
    }
  }

  return { shareUrl, canShare };
}
